import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

const LatestProducts = () => {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const BROWN = "#5b3a29";
  const OLIVE = "#8a8f3a";
  const WHITE = "#ffffff";

  useEffect(() => {
    const fetchLatestProducts = async () => {
      try {
        const productsRef = collection(db, "products");
        const q = query(productsRef, orderBy("createdAt", "desc"), limit(6));
        const snapshot = await getDocs(q);
        const latest = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProducts(latest);
      } catch (error) {
        console.error("خطأ أثناء جلب أحدث المنتجات:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestProducts();
  }, []);

  const handleAddToCart = (product) => {
    addToCart(product);
    toast.success(`${product.name} تم إضافته للسلة! 🛒`);
  };

  const section = { background: WHITE, padding: "80px 20px", fontFamily: "Inter, system-ui, sans-serif" };
  const title = { textAlign: "center", color: BROWN, fontSize: 36, fontWeight: 700, marginBottom: 40 };
  const grid = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: 24, maxWidth: 1200, margin: "auto" };
  const card = { borderRadius: 12, overflow: "hidden", boxShadow: "0 4px 14px rgba(0,0,0,0.08)", transition: "transform 0.3s ease", background: "#fff", border: `1px solid ${OLIVE}33` };
  const image = { width: "100%", height: 240, objectFit: "cover" };
  const info = { padding: 16, textAlign: "center" };
  const name = { fontSize: 18, fontWeight: 600, color: BROWN, marginBottom: 8 ,   height: 48, // ✅ تثبيت ارتفاع الاسم (مثلاً 2 سطر تقريباً) 
  overflow: "hidden"  };
  const price = { fontSize: 16, color: OLIVE, fontWeight: 700, marginBottom: 12 };
  const button = { background: BROWN, color: WHITE, border: "none", padding: "10px 18px", borderRadius: 8, fontWeight: 600, cursor: "pointer", transition: "background 0.3s ease" };
  const buttonContainer = { display: "flex", justifyContent: "center", gap: "10px" };

  const responsive = `
    .latest-card:hover { transform: translateY(-5px); }
    .latest-card button:hover { opacity: 0.9; }
  `;

  if (loading) return <p style={{ textAlign: "center", fontSize: 20 }}>⏳ جاري تحميل أحدث المنتجات...</p>;
  if (products.length === 0) return <p style={{ textAlign: "center", fontSize: 18 }}>لا توجد منتجات متاحة حالياً</p>;

  return (
    <section style={section} id="latest">
      <Toaster position="top-right" />
      <style>{responsive}</style>
      <h2 style={title}>Latest Products</h2>
      <div style={grid}>
        {products.map((p) => (
          <div key={p.id} style={card} className="latest-card">
            <img src={p.imageUrl} alt={p.name} style={image} />
            <div style={info}>
              <h3 style={name}>{p.name}</h3>
              <p style={price}>{p.price} EGP</p>
              <div style={buttonContainer}>
                <button style={button} onClick={() => handleAddToCart({ id: p.id, name: p.name, price: p.price, image: p.imageUrl })}>
                  Add to Cart
                </button>
                <button style={{ ...button, background: OLIVE }} onClick={() => navigate(`/product/${p.id}`)}>
                  View Product
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LatestProducts;
